import React, { useEffect, useState } from 'react';
import './AirBubble.css';

const AirBubble = () => {
  const [bubbles, setBubbles] = useState([]);
  const [clickedBubbles, setClickedBubbles] = useState([]);
  const [burstOrder, setBurstOrder] = useState([]);

  useEffect(() => {
    const generateBubbles = () => {
      const newBubbles = [];
      const bubbleNumbers = Array.from({ length: 50 }, (_, index) => index + 1);

      // Shuffle the bubble numbers randomly
      for (let i = bubbleNumbers.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [bubbleNumbers[i], bubbleNumbers[j]] = [bubbleNumbers[j], bubbleNumbers[i]];
      }

      for (let i = 0; i < 50; i++) {
        const bubble = {
          id: i,
          number: bubbleNumbers[i],
          left: Math.random() * 250 + 'px',
          top: Math.random() * 450 + 'px',
          size: Math.random() * 20 + 30 + 'px',
        };
        newBubbles.push(bubble);
      }
      setBubbles(newBubbles);
    };

    generateBubbles();
  }, []);

  const handleBubbleClick = (id, number) => {
    setClickedBubbles((prev) => [...prev, id]);
    setBurstOrder((prev) => [...prev, number]);
  };

  return (
    <div className="flex flex-col justify-center items-center h-screen-full">
      <div className="bubble-container relative">
        {bubbles.map((bubble) => (
          <div
            key={bubble.id}
            className={`bubble ${clickedBubbles.includes(bubble.id) ? 'burst' : ''}`}
            style={{
              left: bubble.left,
              top: bubble.top,
              width: bubble.size,
              height: bubble.size,
            }}
            onClick={() => handleBubbleClick(bubble.id, bubble.number)}
          />
        ))}
      </div>
      <div className="burst-numbers">
        {burstOrder.map((number, index) => (
          <span key={index} className="burst-number">
            {number}
          </span>
        ))}
      </div>
    </div>
  );
};


export default AirBubble;
